import { create } from 'zustand';
import notificationService from '../services/notificationService';

const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,
  loading: false,

  fetchNotifications: async (analysisId, userId) => {
    if (!analysisId) return;
    set({ loading: true });
    try {
      const data = await notificationService.getNotifications(analysisId);
      if (data.success) {
        const unread = data.notifications.filter(
          (n) => userId && !(n.readBy || []).includes(userId)
        ).length;
        set({ notifications: data.notifications, unreadCount: unread, loading: false });
      } else {
        set({ loading: false });
      }
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
      set({ loading: false });
    }
  },

  addNotification: (notification) =>
    set((state) => ({
      notifications: [notification, ...state.notifications],
      unreadCount: state.unreadCount + 1
    })),

  markAsRead: async (id, userId) => {
    try {
      await notificationService.markAsRead(id);
      set((state) => ({
        notifications: state.notifications.map((n) =>
          n._id === id ? { ...n, readBy: [...(n.readBy || []), userId] } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - 1)
      }));
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
    }
  },

  markAllAsRead: async (analysisId, userId) => {
    if (!analysisId) return;
    try {
      await notificationService.markAllAsRead(analysisId);
      set((state) => ({
        notifications: state.notifications.map((n) => ({
          ...n,
          readBy: [...(n.readBy || []), userId]
        })),
        unreadCount: 0
      }));
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
    }
  },

  reset: () => set({ notifications: [], unreadCount: 0, loading: false })
}));

export default useNotificationStore;
